import React, { useEffect, useState } from 'react';
import DGLTH_receipt from '../components/DGLTH_receipt';
import DGLTH_voyage from '../components/DGLTH_voyage';
import DGLTH_voyage_double from '../components/DGLTH_voyage_double';



export default function DataGridLastTdHook({ item, props, entity = null, refreshData}) {


    useEffect(() => {
        
    }, []);



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch(entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'receipt': return (
                            <>
                                <DGLTH_receipt entity={'receipt'} item={item} />
                            </>
                        );
                        case 'gyv_voyage': return (
                            <>
                                <DGLTH_voyage entity={'voyage'} item={item} refreshData={refreshData} />
                            </>
                        );
                        case 'gyv_voyage_double': return (
                            <>
                                <DGLTH_voyage_double entity={'gyv_voyage_double'} item={item} refreshData={refreshData} />
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};